import {Component} from '@angular/core';
import { AuthService, RoutingService, TranslationService, TranslatePipe, UrlPipe } from '@spartacus/core';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {OrderType} from '../../model/cart-administration.model';
import {CartParametersService} from '../../services/cart-parameters.service';
import {LoginComponent} from '@spartacus/user/account/components';
import {UserAccountFacade} from '@spartacus/user/account/root';
import { PageSlotComponent } from '@spartacus/storefront';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-login',
    templateUrl: './efa-login.component.html',
    imports: [PageSlotComponent, RouterLink, AsyncPipe, TranslatePipe, UrlPipe]
})
export class EfaLoginComponent extends LoginComponent {
  currentOrderType$: Observable<OrderType> =
    this.cartParametersService.getCurrentOrderType();
  isHomePage$: Observable<boolean> = this.routingService
    .getRouterState()
    .pipe(map((state) => state.state.url.slice(-1) === '/'));

  constructor(
    private routingService: RoutingService,
    protected cartParametersService: CartParametersService,
    auth: AuthService,
    protected userFacade: UserAccountFacade,
    translation: TranslationService,
  ) {
    super(auth, userFacade, translation);
  }
}
